import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import RecipesPage from "@/pages/RecipesPage";
import RecipeDetailPage from "@/pages/RecipeDetailPage";
import AllergenMatrixPage from "@/pages/AllergenMatrixPage";
import ProductionPage from "@/pages/ProductionPage";
import StockPage from "@/pages/StockPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";
import InventoryPage from "@/pages/InventoryPage";
import LocationsPage from "@/pages/LocationsPage";
import UsersPage from "@/pages/UsersPage";
import SitesPage from "@/pages/SitesPage";
import PublicAllergensPage from "@/pages/PublicAllergensPage";
import SuppliersPage from "@/pages/SuppliersPage";
import SupplierDetailPage from "@/pages/SupplierDetailPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import SupplierPortalPage from "@/pages/SupplierPortalPage";
import LabelsPage from "@/pages/LabelsPage";
import PresentationPage from "@/pages/PresentationPage";
import LogisticsPage from "@/pages/LogisticsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/public/allergeni/:siteId" element={<PublicAllergensPage />} />
          <Route path="/portale/:token" element={<SupplierPortalPage />} />
          <Route path="/presentazione" element={<PresentationPage />} />
          <Route element={<AppShell />}>
            <Route path="/fornitori" element={<SuppliersPage />} />
            <Route path="/fornitori/:id" element={<SupplierDetailPage />} />
            <Route path="/ordini" element={<OrdersPage />} />
            <Route path="/ordini/:id" element={<OrderDetailPage />} />
            <Route path="/logistica" element={<LogisticsPage />} />
            <Route path="/etichette" element={<LabelsPage />} />
            <Route path="/" element={<DashboardPage />} />
            <Route path="/ricette" element={<RecipesPage />} />
            <Route path="/ricette/:id" element={<RecipeDetailPage />} />
            <Route path="/allergeni" element={<AllergenMatrixPage />} />
            <Route path="/produzione" element={<ProductionPage />} />
            <Route path="/scorte" element={<StockPage />} />
            <Route path="/scorte/:id" element={<ArticleDetailPage />} />
            <Route path="/inventario" element={<InventoryPage />} />
            <Route path="/ubicazioni" element={<LocationsPage />} />
            <Route path="/utenti" element={<UsersPage />} />
            <Route path="/sedi" element={<SitesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
